import React from 'react';
import {isParseableDate} from 'go/components/rules/rules';
import {rulesMap} from 'go/components/rules/rules';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {DateField as _DateField} from 'app-ui-componentlibrary/dist/componentLibrary/form/DateField';

const dateCheckRule = isParseableDate();
export const DateField = (props) => (
  <_DateField {...props} {...{rulesMap}} {...{dateCheckRule}} />
);
export default connectDynamic(DateField);
